import PropTypes from 'prop-types';
import React from 'react';
import { POWER6_KEYS } from '../../../utils/constants';
import styles from '../search.scss';

const CollegeHeaderColumns = props => {
    const { filterType, colleges, isPowerUser, isRostersRolloutEnabled } = props;
    const power6SortKey = isRostersRolloutEnabled ? POWER6_KEYS.ACTIVE_ROSTER : POWER6_KEYS.SCHOOL;

    let sortValue = '';
    if (colleges.sort && colleges.sort.field) {
        sortValue = `${colleges.sort.field}_${colleges.sort.asc ? 'asc' : 'desc'}`;
    }
    const sortOptions = [
        { value: 'name_asc', label: 'Name: A to Z' },
        { value: 'name_desc', label: 'Name: Z to A' },
        { value: `${power6SortKey}_asc`, label: 'P6: Low to high' },
        { value: `${power6SortKey}_desc`, label: 'P6: High to low' },
        /* { value: 'conference.conferenceName_asc', label: 'Conf: A to Z' },
        { value: 'conference.conferenceName_desc', label: 'Conf: Z to A' },
        { value: 'conference.division.divisionName_asc', label: 'Div: A to Z' },
        { value: 'conference.division.divisionName_desc', label: 'Div: Z to A' }, */
    ];

    const sort = (val) => {
        const sortBy = val.split('_');
        props.sortResults('colleges', sortBy[0], sortBy[1]);
    };

    function sortDefaultDesc(type, field) {
        if (colleges.sort.field !== field || (colleges.sort.field === field && colleges.sort.asc === false)) {
            props.sortResults(type, field, 'asc');
        } else {
            props.sortResults(type, field, 'desc');
        }
    }

    return (
        colleges.total > 0
            ? (
                <div>
                    <div className={`${styles.searchHeaders} d-none d-md-flex`} data-testid="search.colleges.column-headers">
                        <div className="flex-grow">
                            <div className="row">
                                <div
                                    className={`col-md-5 ${styles.searchHeaderColumn} ${filterType && styles.clickable} ${filterType && colleges.sort.field === 'name' ? 'active' : ''}`}
                                    onClick={() => { return filterType ? props.sortResults('colleges', 'name') : null; }}
                                    data-testid="search.colleges.column-header.name"
                                >
                                    {(filterType ? <span data-testid="search.colleges.column-header.name-label">Name <i className={`uts ${colleges.sort.field === 'name' && !colleges.sort.asc ? 'uts-expand' : 'uts-collapse'}`} /></span> : <span data-testid="search.colleges.column-header.name-label">Colleges</span>)}
                                </div>
                                <div className={`col-md-3 ${styles.searchHeaderColumn}`} data-testid="search.colleges.column-header.location">Location</div>
                                <div className={'col-md-4'}>
                                    <div className="row w-100">
                                        {isPowerUser && (
                                            <div
                                                className={`col-sm-4 ${styles.searchHeaderColumn} ${filterType && styles.clickable} ${filterType && colleges.sort.field === power6SortKey ? 'active' : ''}`}
                                                onClick={() => { return filterType ? sortDefaultDesc('colleges', power6SortKey) : null; }}
                                                data-testid="search.colleges.column-header.p6"
                                            >
                                                P6 {(filterType && <i className={`uts ${colleges.sort.field === power6SortKey && !colleges.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />)}
                                            </div>
                                        )}
                                        {/* <div
                                        className={`col-sm-4 ${styles.searchHeaderColumn} ${filterType && styles.clickable} ${filterType && colleges.sort.field == 'school.conference.division.divisionName' ? 'active' : ''}`}
                                        onClick={() => { return filterType ? props.sortResults('colleges', 'school.conference.division.divisionName') : null }}>
                                        Div {(filterType && <i className={`uts ${colleges.sort.field == 'school.conference.division.divisionName' && !colleges.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />)}
                                    </div>
                                    <div
                                        className={`col-sm-4 ${styles.searchHeaderColumn} ${filterType && styles.clickable} ${filterType && colleges.sort.field == 'school.conference.conferenceName' ? 'active' : ''}`}
                                        onClick={() => { return filterType ? props.sortResults('colleges', 'school.conference.conferenceName') : null }}>
                                        Conf {(filterType && <i className={`uts ${colleges.sort.field == 'school.conference.conferenceName' && !colleges.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />)}
                                    </div> */}
                                        <div className={`col-sm-4 ${styles.searchHeaderColumn}`} data-testid="search.colleges.column-header.div">Div</div>
                                        <div className={`col-sm-4 ${styles.searchHeaderColumn}`} data-testid="search.colleges.column-header.conf">Conf</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.searchHeaders} d-block d-md-none`} data-testid="search.colleges.column-headers-mobile">
                        {filterType ? (
                            <div className={``} data-testid="search.colleges.sort-by-wrapper">
                                Sort by
                                <select
                                    className="inline-input"
                                    value={sortValue}
                                    onChange={(e) => sort(e.target.value)}
                                    data-testid="search.colleges.sort-select"
                                >
                                    <option value="">Relevance</option>
                                    {sortOptions.map((option, i) => <option value={option.value} key={`collegeSort${i}`}>{option.label}</option>)}
                                </select>
                            </div>
                        ) : 'Colleges'}
                    </div>
                </div>
            ) : <div />
    );
};

CollegeHeaderColumns.propTypes = {
    colleges: PropTypes.objectOf(PropTypes.any).isRequired,
    filterType: PropTypes.string,
    isPowerUser: PropTypes.bool,
    isRostersRolloutEnabled: PropTypes.bool,
    sortResults: PropTypes.func,
};

CollegeHeaderColumns.defaultProps = {
    filterType: '',
    isPowerUser: false,
    isRostersRolloutEnabled: false,
    sortResults: () => {},
};

export default CollegeHeaderColumns;
